<div
  class="colorpicker-wrapper"
  [attr.data-size]="config.size || 'medium'"
  [class.has-value]="hasValue"
>
  <!-- Label -->
  <label
    *ngIf="config.label"
    [attr.for]="inputId"
    class="colorpicker-label"
    [class.required]="config.required"
  >
    {{ config.label }}
    <sup *ngIf="config.required" class="required-indicator">*</sup>
  </label>

  <!-- Colorpicker Container -->
  <div class="colorpicker-container" [class.has-error]="showErrorState">
    <!-- Simple Color Picker View -->
    <kendo-colorpicker
      *ngIf="config.view === 'simple'"
      [id]="inputId"
      [(value)]="colorValue"
      [format]="kendoFormat"
      [disabled]="config.disabled ?? false"
      [readonly]="config.readonly ?? false"
      [tabIndex]="config.tabIndex ?? 0"
      (valueChange)="handleValueChange($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur()"
      (open)="handleOpen()"
      (close)="handleClose()"
      class="custom-colorpicker"
    >
    </kendo-colorpicker>

    <!-- Gradient Color Picker View -->
    <kendo-colorgradient
      *ngIf="config.view === 'gradient'"
      [id]="inputId + '-gradient'"
      [(value)]="colorValue"
      [format]="kendoFormat"
      [disabled]="config.disabled ?? false"
      [readonly]="config.readonly ?? false"
      [tabIndex]="config.tabIndex ?? 0"
      [opacity]="config.opacity ?? false"
      [clearButton]="config.clearButton ?? false"
      (valueChange)="handleValueChange($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur()"
      class="custom-colorgradient"
    >
    </kendo-colorgradient>

    <!-- Palette Color Picker View -->
    <kendo-colorpalette
      *ngIf="config.view === 'palette'"
      [id]="inputId + '-palette'"
      [(value)]="colorValue"
      [palette]="paletteColors"
      [columns]="config.paletteColumns || 10"
      [tileSize]="tileSize"
      [disabled]="config.disabled ?? false"
      [readonly]="config.readonly ?? false"
      [tabIndex]="config.tabIndex ?? 0"
      (valueChange)="handleValueChange($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur()"
      class="custom-colorpalette"
    >
    </kendo-colorpalette>

    <!-- Inline Input with Color Preview -->
    <div class="color-input-group" *ngIf="config.showInput">
      <div
        class="color-preview"
        [style.background-color]="colorValue || '#000000'"
        [style.width.px]="config.previewSize || 30"
        [style.height.px]="config.previewSize || 30"
        (click)="!config.disabled && onFileSelectClick()"
      ></div>
      <input
        type="text"
        class="k-textbox k-input k-input-md k-rounded-md k-input-solid color-input"
        [value]="displayValue"
        [disabled]="config.disabled"
        [readonly]="config.readonly || !config.allowManualInput"
        [placeholder]="config.placeholder || '#000000'"
        (input)="handleManualInput($event)"
        (blur)="handleInputBlur()"
      />
    </div>

    <!-- Quick Color Swatches -->
    <div class="quick-colors" *ngIf="config.quickColors && config.quickColors.length > 0">
      <button
        *ngFor="let color of config.quickColors"
        type="button"
        class="quick-color-button"
        [style.background-color]="color"
        [title]="color"
        [disabled]="config.disabled"
        (click)="selectQuickColor(color)"
      ></button>
    </div>
  </div>

  <!-- Helper Text Area -->
  <div class="helper-text" *ngIf="(config.hint && !showErrorState) || showErrorState">
    <span *ngIf="config.hint && !showErrorState" class="hint-text">{{ config.hint }}</span>
    <span *ngIf="showErrorState" class="error-text">* {{ currentErrorMessage }}</span>
  </div>
</div>
